import React from 'react';

import Permissions from '@/lib/permissions';
import AppPage from '@/ui/AppPage/AppPage';

import Groblja from '@/models/groblja/groblja';
import MapCentricPage from '@/ui/MapCentric/MapCentricPage';

const PopisGrobljaMapCentricPage = () => (
    <AppPage titlett="groblja:titles.popis_groblja" needPermission={[Permissions.Groblja]}>
      <MapCentricPage
        model={Groblja}
        titleToken="groblja:titles.popis_groblja"
        view="default"
        baseRecordPath=""
        mapId={44}
        mapModel={Groblja}
      />
    </AppPage>
  );

export default PopisGrobljaMapCentricPage;
